import { generatedAPI } from './endpoints.gen';

export const shortURLAPIv1alpha1 = generatedAPI.enhanceEndpoints({});
